const initialeState = {
    initForm: false,
    formData: {id: 'formData'},
    saveFormData: null,
    demandeur: null,
    listDataRef: [],
    countTotalDataRef: null,
    formLinks: [],
    addressBien: null,
    dataFormIsReady: false,
    currentDetailForm: null,
}


const FormsReducer = (state=initialeState, action) => {
    switch (action.type) {
        case  'INIT_FORM':
            return {
                ...state,
                initForm: action.data.formRef,
            }
        case 'SET_CURRENT_DETAIL_FORM':
            return {
                ...state,
                currentDetailForm: action.data,
            }
        case 'RESET_FORM':
            return {
                ...state,
                initForm: false
            }
        case 'UPDATE_FORM_DATA':
            return {
                ...state,
                formData: {
                    ...state.formData,
                    [action.data.key]: action.data},
                    listDataRef: _.uniq([...state.listDataRef,action.data.key])
                }
        case 'UPDATE_FORM_LINKS':
            return {
                ...state,
                formLinks: {
                    ...state.formLinks,
                    [action.data.key] : action.data.links
                }
            }
        case 'UPDATE_DEMANDEUR_INFO':
            return {
                ...state,
                demandeur : action.data.demInfo,
            }
        case 'SAVE_FORM_DATA':
            return {
                ...state,
                saveFormData : action.data.form_ref_id,
            }
        case 'SAVE_FORM_LINKS':
            return {
                ...state,
                formLinks : action.data,
            }
        case 'SAVE_ADDRESS_BIEN':
            return{
                ...state,
                addressBien: action.data
            }

        case 'SET_COUNT_TOTAL-DATA_REF':
            return {
                ...state,
                countTotalDataRef: action.data,
            }
        case 'RESET_LIST_DATA_REF':
            return{
                ...state,
                listDataRef: []
            }
        case 'DATA_FORM_IS_READY':
            return{
                ...state,
                dataFormIsReady:  action.data
            }
        default:
            return state
    }
}

export default FormsReducer
